import get from 'lodash/get';
import React, { useEffect } from 'react';
import moment from 'moment';
import { useAwaitControl } from 'react-redux-await-control';
import { useTheme } from 'styled-components';
import { getTicketDetails } from '~/store/tickets/actions';
import { LOAN_TYPE_NAMES } from '~/typings/enums/LoanType';
import { TicketPriorities, TicketPrioritiesColors } from '~/typings/enums/Ticket/TicketPriorities';
import { TicketStatusColors } from '~/typings/enums/Ticket/TicketStatus';
import { Flag } from '~/ui/assets/icons';
import { Flex, Tag, Tooltip } from '~/ui/components';
import { getTicketCreationOriginVisual } from '~/components/Ticket/common/ticketCreationOrigin';
import {
  TicketCard,
  TicketHeader,
  ResponsibleInfo,
  TicketContent,
  TicketField,
  IdInfo,
  LinkField,
  OpenTag,
  SlaInfo,
  NewBadge,
} from './KanbanCard.styled';

interface KanbanCardProps {
  item: any;
  onClick?: (item: any) => void;
  onUpdateItem?: (item: any) => void;
}

export function KanbanCard({ item, onClick, onUpdateItem }: KanbanCardProps) {
  const { colors } = useTheme();
  const openedBy = getTicketCreationOriginVisual(item?.creationOrigin, colors);

  const ticketDetailsControl = useAwaitControl(getTicketDetails);
  const ticketDetailsSuccess = ticketDetailsControl.result(item?.id);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target instanceof HTMLAnchorElement) {
      return;
    }
    onClick?.(item);
  };

  const renderPriorityFlag = () => {
    const colorName = TicketPrioritiesColors?.[item.priorityTicket];
    const color = get(colors, colorName) || 'gray';

    return (
      <Tooltip content={TicketPriorities?.[item.priorityTicket]} small>
        <Flag width={24} height={24} color={color} />
      </Tooltip>
    );
  };

  useEffect(() => {
    if (ticketDetailsSuccess) {
      onUpdateItem?.(ticketDetailsSuccess);
    }
  }, [ticketDetailsSuccess]);

  return (
    <TicketCard onClick={handleClick} isNew={item.new}>
      <TicketHeader>
        {renderPriorityFlag()}

        <IdInfo color="element.secondary">
          #{item?.id}
          {item?.new && <NewBadge>Novo</NewBadge>}
          <Tag {...TicketStatusColors?.[item?.ticketStatusId]}>{item?.statusTicket}</Tag>
        </IdInfo>
      </TicketHeader>

      <TicketContent>
        {/* {openedBy?.label?.length ? ( */}
        {/*   <OpenTag> */}
        {/*     {openedBy.icon} */}
        {/*     <span>{openedBy.label}</span> */}
        {/*   </OpenTag> */}
        {/* ) : null} */}

        <Flex justify="space-between" gap={8} align="center">
          <ResponsibleInfo>
            <span>{moment(item?.ticketOpeningDate).format('DD/MM/YYYY')}</span>
          </ResponsibleInfo>

          {!!item?.slaDays && (
            <Flex align="center" justify="flex-end" width="auto" gap={10}>
              <SlaInfo>
                SLA{' '}
                <b>
                  {item?.slaDays} {item?.slaDays > 1 ? 'dias' : 'dia'}
                </b>
              </SlaInfo>
            </Flex>
          )}
        </Flex>

        <Flex justify="space-between" gap={8} align="center">
          <TicketField>
            Produto: <strong>{LOAN_TYPE_NAMES?.[item?.product] || item?.product || 'Não especificado'}</strong>
          </TicketField>
        </Flex>

        <Flex justify="space-between" gap={8} align="center">
          <TicketField>
            Motivo: <strong>{item?.reason || 'Não especificado'}</strong>
          </TicketField>

          <TicketField align="flex-end">
            Person ID: <LinkField to={`/backoffice/people/${item?.personId}`}>{item?.personId}</LinkField>
          </TicketField>
        </Flex>
      </TicketContent>
    </TicketCard>
  );
}
